<template>
  <div class="guess">
    <div class="guess-page">
      <img src="@/assets/home/zylc-icon.png"
           class="zylc">
      <div class="guess-box">
        <img src="@/assets/guess/icon.png"
             class="guess-icon">
        <img :src="friInfo.avatar || require('@/assets/guess/silent-img.png')"
             class="fri-avatar">
        <!-- <p class="fri-nickname"
           v-if="friInfo.nickname.length > 6">{{friInfo.nickname.slice(0, 6)}}...</p>
        <p class="fri-nickname"
           v-else>{{friInfo.nickname || '神秘好友'}}</p> -->
        <div class="select-box">
          <div v-for="(item, index) in friInfo.wish"
               :key="index"
               class="select-item"
               @click="handleSelect(item)">
            <!-- <img :src="require(`@/assets/wish/${item.wish}.png`)"
                 class="select-img"> -->
            <img :src="`https://public-oss.inrice.cn/zylc-guess-card/wish/${item.wish}.png`"
                 class="select-img">
            <img src="@/assets/guess/ischoose.png"
                 class="select-icon"
                 v-if="chooseList.includes(item.wish)">
          </div>
        </div>
        <button class="select-btn"
                @click="guessResult"></button>
      </div>
    </div>
  </div>
</template>

<script>
import { toParams } from '@/utils/to-params'
import { Toast } from 'vant'
import Mia from '@inrice/mars-mia'
export default {
  data () {
    return {
      uWishId: null,
      userId: null,
      friInfo: [],
      chooseList: [],
      gueList: [],
      chooseLen: 0,
      tacit_value: null,
      desc: null,
      textList1: [
        '那就把下一次见面，换成明天见。',
        '新的故事会在夏天温柔的晚风中开始。',
        '梨子橙汁苹果汁，你是我的好铁汁。',
        '季节轮换，我们的友谊不变。',
        '你未必光芒万丈，但始终温暖有光。',
        '夏天很浪漫，空了一起吃顿饭。',
        '我们故事从打开一瓶冰镇汽水开始。',
        '好像所有的美好都发生在此刻。',
        '最好的陪伴是你我都一直在。',
        '相处起来舒服的关系是份礼物。',
        '谢谢你来我的世界温暖我。',
        '有你在身边，风都格外甜。'
      ],
      textList2: [
        '最好的陪伴是，你我都一直在。',
        '我们不是夏日限定，我们是来日方长。',
        '相处起来舒服的关系是份礼物。',
        '有时候词不达意，但感谢身边有你。',
        '这个夏天你又会带来什么惊喜呢？',
        '感情保鲜的秘诀是：常常联系。',
        '愿你的快乐店铺永不打烊。',
        '好好生活，下次还要一起分享好消息。',
        '快乐的标配，美食和你在一起的时间。',
        '向海风许愿，在山海相见。',
        '浪漫的不是夕阳，而是你。',
        '温柔是宝藏，你也是。'
      ],
      textList3: [
        '很庆幸遇见你，这是属于我们的故事。',
        '感情不需要句子，我们就是最好的证明。',
        '漫游银河也想和你相伴。',
        '你的出现对我来说就是一束光。',
        '风已有夏的味道，互不相见时也在思念对方。',
        '最好的感情是各自忙碌，互相牵挂。',
        '世界上最好吃的面，都不如见你一面。',
        '陪伴是最浪漫的告白。',
        '有事没事，见一面。',
        '你与星光同样浪漫。',
        '成为更好的自己，这是我们新的约定。',
        '有你作伴，哪里都是春天。'
      ],
      textList4: [
        '不愧是我们。',
        '没有特别的事，但有一个特别的你。',
        '我不善言辞，还好有你懂我。',
        '巧的是你总懂我的欲言又止。',
        '要和你见很多次面。',
        '你是我一辈子都想炫耀的人。',
        '有时候词不达意，但感谢身边有你。',
        '懂我的奇奇怪怪，陪你可可爱爱。',
        '很庆幸遇见你，这是属于我们的故事。',
        '感情不需要句子，我们就是最好的证明。',
        '久违亦如初见，亲切且新鲜。',
        '路虽不同，但从未走远。'
      ]
    }
  },
  async created () {
    this.$parent.$refs.music.hideMusic()
    const { wishId = '' } = toParams()
    if (!Number(wishId)) {
      this.$router.push('./home')
    }
    // console.log(wishId, 'wishid friid')
    this.uWishId = wishId
    this.$banShare()
    this.getAct()
    await this.getUser()
    await this.getWishList(wishId)
  },
  methods: {
    // 活动接口
    async getAct () {
      const { data } = await this.$fetch.get('/may-day-wish/act')
      console.log('act:', data)
      this.setWechatTitle(data.title)
      return {}
    },
    // 设置活动标题
    setWechatTitle (title) {
      document.title = title
      var iframe = document.createElement('iframe')
      iframe.style.visibility = 'hidden'
      iframe.setAttribute('src', 'https://www.baidu.com/img/baidu_jgylogo3.gif')
      var iframeCallback = function () {
        setTimeout(function () {
          iframe.removeEventListener('load', iframeCallback)
          document.body.removeChild(iframe)
        }, 0)
      }
      iframe.addEventListener('load', iframeCallback)
      document.body.appendChild(iframe)
    },
    // 用户接口
    async getUser () {
      const { data } = await this.$fetch.get('/may-day-wish/user')
      console.log('user:', data)
      this.userId = data.id
      return {}
    },
    async getWishList (key) {
      const { data } = await this.$fetch.get(`/may-day-wish/get-wish/${key}`)
      console.log(data, 'getwish')
      this.friInfo = data
      if (data.user_id === this.userId) {
        this.$router.push('./home')
      }
      if (data.is_invite === 1) {
        this.$router.push({
          path: 'result',
          query: {
            wishId: this.uWishId
          }
        })
      }
    },
    handleSelect (item) {
      if (this.chooseList.includes(item.wish)) {
        for (let i = 0; i < this.chooseList.length; i++) {
          if (this.chooseList[i] === item.wish) {
            this.chooseList.splice(i, 1)
            this.delResult(item)
          }
        }
        const arr2 = new Set(this.chooseList)
        this.chooseLen = [...arr2].length
        return
      }
      if (this.chooseLen === 6) {
        Toast('最多可选6个事件哟~')
        return
      }
      this.chooseList.push(item.wish)
      this.gueList.push(item)
      const arr1 = new Set(this.chooseList)
      this.chooseLen = [...arr1].length
    },
    delResult (item) {
      for (let i = 0; i < this.gueList.length; i++) {
        if (this.gueList[i] === item) {
          this.gueList.splice(i, 1)
        }
      }
    },
    async guessResult () {
      Mia.clickStat('guess_btn')
      if (this.chooseLen !== 6) {
        Toast('需选够6个事件哟~')
        return
      }
      let n = 0
      this.gueList.forEach((item) => {
        if (item.isWish) {
          n++
        }
      })
      // console.log(n)
      switch (n) {
        case 3:
          this.tacit_value = '50%'
          this.desc = this.textList1[Math.floor(Math.random() * this.textList1.length + 1) - 1]
          break
        case 4:
          this.tacit_value = '67%'
          this.desc = this.textList2[Math.floor(Math.random() * this.textList2.length + 1) - 1]
          break
        case 5:
          this.tacit_value = '83%'
          this.desc = this.textList3[Math.floor(Math.random() * this.textList3.length + 1) - 1]
          break
        case 6:
          this.tacit_value = '100%'
          this.desc = this.textList4[Math.floor(Math.random() * this.textList4.length + 1) - 1]
          break
      }
      try {
        const { data } = await this.$fetch.post('/may-day-wish/invite', {
          count: n,
          tacit_value: this.tacit_value,
          wish_id: this.uWishId,
          desc: this.desc
        })
        console.log('invite', data)
        // this.$router.push('/result')
        this.$router.push({
          path: 'result',
          query: {
            wishId: this.uWishId,
            count: n
          }
        })
      } catch (error) {
        console.log(error, 'invite err')
        Toast(error.response.data.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.guess {
  width: 100%;
  min-height: 1700px;
  height: 100vh;
  background-color: #cbc2ae;
}
.guess-page {
  position: relative;
  background: url(~@/assets/home/home-bg.png) no-repeat;
  background-size: 100%;
  width: 750px;
  min-height: 1700px;
  padding-top: 128px;
  .zylc {
    width: 212px;
    height: 52px;
    top: 40px;
    left: 48px;
    position: absolute;
    z-index: 2;
  }
  .guess-box {
    width: 652px;
    height: 1360px;
    background: url(~@/assets/guess/guess-bg.png) no-repeat;
    background-size: 100%;
    margin: 0 auto;
    position: relative;
    padding-top: 328px;
    .guess-icon {
      position: absolute;
      width: 230px;
      height: 92px;
      top: 39px;
      left: 209px;
    }
    .fri-avatar {
      position: absolute;
      width: 116px;
      height: 115px;
      top: 136px;
      left: 46px;
    }
    .fri-nickname {
      width: 180px;
      font-size: 24px;
      font-weight: 400;
      color: #000000;
      position: absolute;
      top: 273px;
      left: 15px;
      text-align: center;
    }
    .select-box {
      width: 581px;
      height: 810px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .select-item {
        position: relative;
        .select-img {
          width: 168px;
          height: 247px;
        }
        .select-icon {
          position: absolute;
          width: 42px;
          height: 38px;
          bottom: 40px;
          right: 0;
        }
      }
    }
    .select-btn {
      width: 243px;
      height: 82px;
      display: block;
      margin: 40px auto 0;
      background: url(~@/assets/guess/sure.png) no-repeat;
      background-size: 100%;
    }
  }
}
</style>